import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Link } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../constants';
import { connect } from 'react-redux';
import { getUrlWithToken } from '../../../../utils';

const MobileMenuItem = ({ document }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();
  const open = Boolean(anchorEl);
  const ITEM_HEIGHT = 48;

  const { flowId } = document;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton aria-label='more' aria-controls='long-menu' aria-haspopup='true' onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '30ch'
          }
        }}
      >
        <Link
          onClick={() => getUrlWithToken(`${config.FIRMA_FRONT_URL}/validate/${flowId}`)}
          style={{ textDecoration: 'none' }}
        >
          <MenuItem>
            {t('documentMenu:viewSignedDocument')}
          </MenuItem>
        </Link>
      </Menu>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    appConfig: state.config
  };
};

export default connect(mapStateToProps, null)(MobileMenuItem);
